/**
 * Care Package door helpers: who is looking, and what the recipient was doing
 * when the door asked who she is.
 */

// The chip she tapped, kept across the reload that signs her in.
const CHIP_KEY = 'ma:gift-chip'
const sessionStore = () => { try { return typeof window !== 'undefined' ? window.sessionStorage : null } catch (e) { return null } }

export function rememberGiftChip(inv, key, storage = sessionStore()) {
  try { if (storage) storage.setItem(CHIP_KEY, JSON.stringify({ inv, key })) } catch (e) { /* the chip is simply tapped again */ }
}

/** The remembered chip for THIS package, once ('' when none). */
export function takeGiftChip(inv, storage = sessionStore()) {
  if (!storage) return ''
  let saved = null
  try { saved = JSON.parse(storage.getItem(CHIP_KEY) || 'null') } catch (e) { saved = null }
  if (!saved || saved.inv !== inv) return ''
  try { storage.removeItem(CHIP_KEY) } catch (e) { /* */ }
  return saved.key || ''
}

/**
 * A copied link or an email send sends the package: the page's gift learns it
 * went out (sent, invite, opened), so its button turns from "Gift to Lark" (or
 * "Send it to Mom") into "Read Lark's gift", and there is no second send (R7.12).
 */
export function mergeLinkedGift(current, payload) {
  if (!current) return null
  const { sent, invite, opened } = payload || {}
  return { ...current, sent: !!sent, invite: invite || current.invite || null, opened: !!opened }
}

/**
 * The send screen changed who it is for or how it is signed (Change, before
 * anything went out, 2026-10-21): the page's gift follows, so reopening the
 * screen shows the same lane.
 */
export function mergeChangedGift(current, payload) {
  if (!current || !payload) return current || null
  const keep = ['for_name', 'for_querent', 'signed_as', 'signed_name', 'from_name', 'from_choices', 'gift_note']
  const out = { ...current }
  for (const k of keep) if (payload[k] !== undefined) out[k] = payload[k]
  return out
}

/**
 * The session the landing asks with. The server knows the viewer only by the
 * session; a signed-in browser can hold one that is not tied to its account
 * (opened signed out, then signed in), and then the sender was taken for a
 * stranger: his own package was marked opened and he got the recipient's room.
 * Signed in, ask the server for this account's own session first.
 */
export async function careViewerSession({ signedIn, sessionId, own }) {
  if (!signedIn) return sessionId
  try { return (await own()) || sessionId } catch (e) { return sessionId }
}
